import {Directive, DoCheck, ElementRef, Inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";

@Directive({
  selector: '[jdLabelTip]',
  exportAs: 'jdLabelTip'
})
export class LabelTipDirective implements DoCheck {

  constructor(private _el: ElementRef<HTMLElement>,
              @Inject(PLATFORM_ID) private _platformId: Object) {
  }

  // parseInt(this._computeStyle(el, 'font-size'), 10)

  getFontSize(elem) {
    if (isPlatformBrowser(this._platformId)) {
      if (!window.getComputedStyle) {
        alert('æ¨çæµè§å¨çæ¬è¿ä½ è¯·åçº§æµè§å¨!');
      }
      // console.log(getComputedStyle(elem, null));
      return window.getComputedStyle(elem, null).getPropertyValue('font-size');
    }
  }

  ngDoCheck(): void {
    const el: HTMLElement = this._el.nativeElement;
    console.log(el.innerText.indexOf('ç³æ¥è¦ç´ ç³æ¥ç³æ¥è¦ç´ ç³æ¥'));
    if (el.innerText.indexOf('ç³æ¥è¦ç´ ') > -1) {
      console.log(el.clientWidth);
      console.log(el.scrollWidth);
      console.log(el.offsetWidth);
      console.dir(el.innerText.length);
      const fontSize = this.getFontSize(el);
      console.log(fontSize);
      console.log(parseInt(fontSize, 10) * el.innerText.length);
    }

  }

}
